<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>Cancellation & Refund Policy
            </h1>

        </div>
    </div>
</div>

<div class="el-blog-single-wrapper">
    <div class="container">
        <div class="row gy-4">
            <div class="col-lg-12 col-md-12">

                <div class="el-inner-blog-box el-blogsingle-comment-box el-blgs-comments-wrapper">

                    <div class="el-blgs-comments">


                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>We strive for customer satisfaction, but due to the nature of digital products,
                                    refunds are limited.

                                </h5>

                            </div>
                            <div class="el-blgs-cmt-name">
                                <h5>Final Purchases


                                </h5>

                            </div>
                            <p class="el-para">All payments are final. Refunds are only applicable where explicitly
                                stated as part of ongoing promotional campaigns.

                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments ">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>Package Validity

                                </h5>

                            </div>
                            <p class="el-para">Subscriptions and packages are valid until <b>31st March of the academic
                                    session.</b> No refunds are provided for mid-term
                                cancellations, especially if any content has already been accessed.



                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments ms-0">

                        <div class="el-blgs-cmts ">
                            <div class="el-blgs-cmt-name">
                                <h5>Refund Processing

                                </h5>

                            </div>
                            <div class="ps-2">
                                <li>General Packages: If eligible, refunds are processed within 14 business days.
                                </li>
                                <li>eBooks: Eligible refunds will be processed within 2 business days of request.
                                </li>
                            </div>
                            <!-- <p class="el-para">Ensure your device meets the required specifications before purchasing
                                digital content. We are not liable for refunds if
                                incompatibility or usage limitations are discovered post-purchase.


                            </p> -->

                        </div>
                    </div>


                </div>

            </div>

        </div>
    </div>
</div>